import { faX } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, Box } from "@mui/material";
import { useState } from "react";
import { useMinWidthQuery } from "../../../../hooks/useMediaQuery";

/**
 *
 * @param props
 *  @param props.toggleButton Optional button element to toggle the modal visibility. Either this or toggleButtonText must be provided.
 *  @param props.toggleButtonText If a toggleButton is not provided, this text will be used for a pre-made button. Either this or toggleButton must be provided.
 *  @param props.title Title of the modal
 *  @param props.className Optional class name for the modal container
 *  @param props.children Content of the modal - this will render any elements passed in directly
 * @returns
 */
export default function ModalWidget(props: { toggleButton?: React.ReactNode, toggleButtonText?: React.ReactNode | string, title: string, width?: string, className?: string, children: React.ReactNode }) {
    const [visible, setVisible] = useState<boolean>(false);

    const isSmallWidth = useMinWidthQuery();

    return <div className={props.className} style={{ zIndex: 10 }}>
        <div className="d-flex flex-row" onClick={() => { setVisible(true); }}>
            {props.toggleButton || <button type="button" className="btn">
                {props.toggleButtonText}
            </button>}
        </div>
        <Modal
            open={visible}
            onClose={() => setVisible(false)}
            aria-labelledby="modal-widget-title"
            aria-describedby="modal-widget-description"
        >
            <Box sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                bgcolor: "background.paper",
                boxShadow: 24,
                borderRadius: "5px",
                p: 2.5,
                width: isSmallWidth ? "95vw" : (props.width || "45vw"),
                maxHeight: "86vh",
                overflowY: "auto"
            }}>
                <div className="d-flex flex-row">
                    <h5 id="modal-widget-title">{props.title}</h5>
                    <div className="ms-auto btn btn-outline-dark my-auto"
                        onClick={() => {
                            setVisible(false);
                        }}
                        style={{ cursor: "pointer" }}
                        role="button" aria-label="Close modal"
                    ><FontAwesomeIcon icon={faX} /></div>
                </div>
                <div id="modal-widget-description" className="d-flex flex-column my-3">
                    {props.children}
                </div>
            </Box>
        </Modal>
    </div >
}